var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormItem',{attrs:{"type":"select","values":_vm.list,"name":"Gruppo","cols":_vm.cols,"sm":_vm.sm,"md":_vm.md,"lg":_vm.lg,"xl":_vm.xl,"dense":_vm.dense},model:{value:(_vm.id),callback:function ($$v) {_vm.id=$$v},expression:"id"}})}
var staticRenderFns = []

export { render, staticRenderFns }